import { z } from 'zod';
import { exitIntentPayload, introOfferPayload } from './pricingTest';

export const globalDefaultConfig = z.object({
  points: z.number().optional(),
  waitTimeMinutes: z.number().optional(),
  pointsMultiplier: z.number().optional(),
  waitTimeMultiplier: z.number().optional(),
  premiumStartChapter: z.number().optional(),
  revcatOfferingId: z.string().optional(),
  exitIntentRevcatOfferingId: z.string().optional(),
  introOfferRevcatOfferingId: z.string().optional(),
  premiumChaptersOnly: z.boolean().optional(),
  exitIntentConfig: exitIntentPayload.optional(),
  introOfferConfig: introOfferPayload.optional(),
});

export const defaultConfig = z.object({
  points: z.number().optional(),
  waitTimeMinutes: z.number().optional(),
  pointsMultiplier: z.number().optional(),
  waitTimeMultiplier: z.number().optional(),
  premiumStartChapter: z.number().optional(),
  premiumChaptersOnly: z.boolean().optional(),
});

export const dynamicPricingConfig = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('simple'),
    startChapter: z.number(),
    endChapter: z.number(),
    points: z.number(),
  }),
  z.object({
    type: z.literal('multiplier'),
    startChapter: z.number(),
    endChapter: z.number(),
    pointsMultiplier: z.number(),
  }),
  z.object({
    type: z.literal('dynamic'),
    startChapter: z.number(),
    endChapter: z.number(),
    startPoints: z.number(),
    pointsIncrease: z.number(),
  }),
]);

export const dynamicWaitTimeConfig = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('simple'),
    startChapter: z.number(),
    endChapter: z.number(),
    waitTimeMinutes: z.number(),
  }),
  z.object({
    type: z.literal('multiplier'),
    startChapter: z.number(),
    endChapter: z.number(),
    waitTimeMultiplier: z.number(),
  }),
  z.object({
    type: z.literal('dynamic'),
    startChapter: z.number(),
    endChapter: z.number(),
    startWaitTimeMinutes: z.number(),
    minutesIncrease: z.number(),
  }),
]);

export const dynamicPremiumChaptersConfig = z.object({
  startChapter: z.number(),
  endChapter: z.number(),
});

export const storyConfig = z.object({
  defaultConfig: defaultConfig.optional(),
  dynamicPricing: z.array(dynamicPricingConfig).optional(),
  dynamicWaitTime: z.array(dynamicWaitTimeConfig).optional(),
  dynamicPremiumChapters: z.array(dynamicPremiumChaptersConfig).optional(),
});

export const DeepLinkOverrideDefinition = z.object({
  globalDefault: globalDefaultConfig.optional(),
  storyConfig: z.record(z.string(), storyConfig).optional(),
});

export type DeepLinkOverrideDefinition = z.infer<typeof DeepLinkOverrideDefinition>;
